const RouteConstants = {
    DASHBOARD: '/',
    HOMEDASHBOARD: '/',
    EVENTS: '/events',
    CREATE_EVENT: '/events/create',
    EDIT_EVENT: '/events/edit/:eventID?',
    EVENT_DETAIL: '/events/:eventID/detail',
    USERS: '/users',
    CHANGE_USER: '/changeuser',
    CREATE_USER: '/users/create',
    EDIT_USER: '/users/edit/:userID?',
    EVENT_TRANSIT: '/events/:eventID/transportation/list',
    EVENT_CREATE_TRANSIT: '/events/:eventID/transportation/create',
    EVENT_REGISTER_CREATE: '/events/:eventID/register/create',
    EVENT_ALLSTAR_REGISTER_CREATE:
        '/events/:eventID/allstarregistration/create',
    EVENT_ALLSTAR_EDIT_REGISTER:
        '/events/:eventID/allstarregistration/edit/:registrationID?',
    EVENT_EDIT_REGISTER: '/events/:eventID/register/edit/:registrationID?',
    EVENT_EDIT_TRANSIT: '/events/:eventID/transportation/edit/:transitID?',
    EVENT_PARTICIPANTS: '/events/:eventID/participants',
    EVENT_SCHEDULE: '/events/:eventID/schedule',
    USER_ACTIVITIES: '/events/:eventID/useractivities',
    EVENT_TICKETS: '/events/:eventID/ticket',
    CREATE_EVENT_TICKET: '/events/:eventID/ticket/create',
    EDIT_EVENT_TICKET: '/events/:eventID/ticket/edit/:ticketID?',
    EVENT_TICKET_SETTINGS: '/events/:eventID/ticket/settings',
    EVENT_TICKET_PARTICIPANT: '/events/:eventID/myticket',
    EVENT_HOTEL: '/events/:eventID/hotelbooking/list',
    MODULE: '/events/:eventID/module',
    PROFILE: '/profile',
    EVENT_VIP: '/events/:eventID/vip',
    CREATE_EVENT_VIP: '/events/:eventID/vip/create',
    EVENT_TRANSIT_LIST: '/events/:eventID/transportation',
    EVENT_OUTFIT: '/events/:eventID/outfit',
    CREATE_OUTFIT: '/events/:eventID/outfit/create',
    EDIT_OUTFIT: '/events/:eventID/outfit/edit/:userOutfitID?',
    // REGISTRATION: '/events/registration',
    EVENT_REGISTRATION_LIST: '/events/:eventID/combineregistration',
    EVENT_ALLSTAR_REGISTRATION_LIST: '/events/:eventID/allstarRegistration',
    EVENT_INVITATIONS: '/events/:eventID/invitations',
    SESSION_TIMEOUT: '/sessionTimeOut',
    BRANDING_COLOR: '/events/:eventID/brandingcolor',
    MODULE_PERMISSIONS: '/events/:eventID/permissions',
    EVENT_HOTEL_BOOKING_LIST: '/events/:eventID/hotel',
    SIGNUP: '/signup/:code',
    CREATE_EVENT_HOTEL: '/events/:eventID/hotel/create',
    EDIT_HOTEL_EVENT: '/events/:eventID/hotel/edit/:hotelBookingID?',
    EVENT_AGENT_PROFILE: '/events/agent',
    EVENT_PARTICIPANT_MODULE_STATUS: '/events/:eventID/participantModuleStatus',
    EVENT_PARTICIPANT_MODULE_STATUS_NEW: '/events/:eventID/newParticipantModuleStatus',
    Event_Notification: '/events/:eventID/notification',
    MODULE_NAME: '/events/:eventID/:moduleName',
    EVENT_RESOURCE: '/events/:eventID/resource',
    CREATE_EVENT_RESOURCE: '/events/:eventID/resource/create',
    EDIT_EVENT_RESOURCE: '/events/:eventID/resource/edit/:eventResourceID',
    MY_RESOURCE: '/events/:eventID/myresource',

    EVENT_DRAFT_REGISTRATION_LIST: '/events/:eventID/draftregistration',
    EVENT_DRAFT_REGISTER_CREATE: '/events/:eventID/draftregister/create',
    EVENT_DRAFT_EDIT_REGISTER:
        '/events/:eventID/draftregister/edit/:registrationID?',
    CREATE_DRAFT_EVENT_HOTEL: '/events/:eventID/drafthotel/create',
    EDIT_DRAFT_HOTEL_EVENT: '/events/:eventID/drafthotel/edit/:hotelBookingID?',
    EVENT_DRAFT_HOTEL: '/events/:eventID/draft/hotelbooking/list',
    EVENT_DRAFT_HOTEL_BOOKING_LIST: '/events/:eventID/drafthotel',

    EVENT_SAT_NIGHT_TRANSPORT: '/events/:eventID/satnighttransport/list',
    EVENT_SAT_NIGHT_TRANSPORT_LIST: '/events/:eventID/satnighttransport',
    EVENT_SAT_NIGHT_TRANSPORT_CREATE:
        '/events/:eventID/satnighttransport/create',
    EVENT_SAT_NIGHT_TRANSPORT_EDIT:
        '/events/:eventID/satnighttransport/edit/:transitID?',
    EVENT_SAT_NIGHT_TRANSPORT_ENDUSER_CREATE:
        '/events/:eventID/satnighttransports/create',
    FORGOT_PASSWORD: '/forgotpassword',
    RESET_PASSWORD: '/resetpassword/:code',
    // EVENT_STAFF_SCHEDULE: '/events/:eventID/staffSchedule',
    IN_APP_NOTIFICATIONS: '/appNotifications',
    SOCIAL_RESPONSIBILITY: '/socialResponsibility',
    ASSIGN_ACTIVITIES: '/events/:eventID/assignActivities',
    COMBINE_ASSIGN_ACTIVITIES: '/events/:eventID/combineassignActivities',
    ALL_ACTIVITIES: '/events/:eventID/allActivities',
    COMBINE_ALL_ACTIVITIES: '/events/:eventID/combineallActivities',
    MARK_ACTIVITIES: '/events/:eventID/markActivities',
    COMBINE_MARK_ACTIVITIES: '/events/:eventID/combinemarkActivities',
    CREATE_ALL_ACTIVITIES: '/events/:eventID/activities/create',
    COMBINE_CREATE_ALL_ACTIVITIES: '/events/:eventID/combineactivities/create',
    EDIT_ALL_ACTIVITIES: '/events/:eventID/activities/edit/:allActivityID',
    COMBINE_EDIT_ALL_ACTIVITIES: '/events/:eventID/combineactivities/edit/:allActivityID',
    SET_TIMINGS: '/events/:eventID/setTimings',
    EDIT_EVENT_VIP: '/events/:eventID/vip/edit/:vipID?',
    EVENT_MEDIA_CIRCUIT: '/events/:eventID/mediaCircuit',
    SETTINGS: '/events/:eventID/settings',
    EVENT_SOCIAL_RESPONSIBILITY: '/events/:eventID/socialResponsibility',
    All_STAR_TIKCET: '/events/:eventID/allStarTicket',
    All_STAR_END_USER_TIKCETS: '/events/:eventID/allStarEndUserTicket',
    TRANSPORT_SUMMARY: '/events/:eventID/transportSummary',
    EVENT_NOTES: '/events/:eventID/notes',
    EVENT_NOTES_USER: '/events/:eventID/notesEndUser',
    EVENT_NOTES_DETAILS: '/events/:eventID/notesDetails',
    CHARGE_CARD: '/chargeCard',
    DRAFT_EVENT_TRANSIT_LIST: '/events/:eventID/draftTransportation',
    DRAFT_EVENT_CREATE_TRANSIT: '/events/:eventID/draftTransportation/create',
    DRAFT_EVENT_EDIT_TRANSIT:
        '/events/:eventID/draftTransportation/edit/:transitID?',
    DRAFT_EVENT_TRANSIT: '/events/:eventID/draftTransportation/list',
    DRAFT_COMBINE_EVENT_TRANSIT_LIST: '/events/:eventID/combineTransportation',
    DRAFT_COMBINE_EVENT_CREATE_TRANSIT:
        '/events/:eventID/combineTransportation/create',
    DRAFT_COMBINE_EVENT_EDIT_TRANSIT:
        '/events/:eventID/combineTransportation/edit/:transitID?',
    DRAFT_COMBINE_EVENT_TRANSIT: '/events/:eventID/combineTransportation/list',

    CREATE_ALLSTAR_EVENT_HOTEL: '/events/:eventID/allStarHotel/create',
    EDIT_ALLSTAR_HOTEL_EVENT:
        '/events/:eventID/allStarHotel/edit/:hotelBookingID?',
    EVENT_ALLSTAR_HOTEL: '/events/:eventID/allStarHotel/hotelbooking/list',
    EVENT_ALLSTAR_HOTEL_BOOKING_LIST: '/events/:eventID/allStarHotel',
    ACTIVITY_TRACKER: '/events/:eventID/activitytracker',
    ROSTERS: '/events/:eventID/rosters',
    EVENT_INSTRUCTION: '/events/:eventID/eventInstruction',
    EVENT_HOME_DETAIL: '/events/:eventID/eventHomeDetail',
    END_USER_EVENT_INSTRUCTION: '/events/:eventID/endUserEventInstruction',
    END_USER_EVENT_HOME_DETAIL: '/events/:eventID/endUserEventHomeDetail',
    PRIVATE_VEHICLE_ADMIN_LIST: '/events/:eventID/allstarprivatetransport',
    PRIVATE_VEHICLE_CREATE:
        '/events/:eventID/privateVehicle/create',
    PRIVATE_VEHICLE_EDIT:
        '/events/:eventID/privateVehicle/edit/:priTransportID?',
    PRIVATE_VEHICLE_ENDUSER_CREATE:
        '/events/:eventID/privateVehicles/create',
    KEY_CONTACTS: '/events/:eventID/keycontacts',
    CREDENTIALS: '/events/:eventID/credentials',
    CREDENTIAL_LIST: '/events/:eventID/credential',
    MY_STATS_REPORT: '/events/:eventID/myStatsReport',
    COMBINE_FLIGHT_INFO: '/events/:eventID/combineflightinfo',
    COMBINE_FLIGHT_INFOLIST: '/events/:eventID/flightinfo',
    COMBINE_CREATE_FLIGHTINFO: '/events/:eventID/combineflightinfo/create',
    COMBINE_EDIT_FLIGHTINFO: '/events/:eventID/combineflightinfo/edit/:flightinfoID?',
    LUNCHROOM: '/events/:eventID/lunchrooms',
    LUNCHROOM_LIST: '/events/:eventID/lunchroom',
    GREENROOM: '/events/:eventID/greenrooms',
    GREENROOM_LIST: '/events/:eventID/greenroom',
    CREATE_GREEN_ROOM: '/events/:eventID/greenroom/create',
    EDIT_GREEN_ROOM: '/events/:eventID/greenroom/edit/:greenRoomID?',
    DRAFT_FLIGHT_INFO_ADMIN_LIST: '/events/:eventID/draftFlightInfo',
    DRAFT_FLIGHT_INFO_LIST: '/events/:eventID/draftFlightInfoList',
    DRAFT_CREATE_FLIGHT_INFO: '/events/:eventID/draftFlightInfo/create',
    DRAFT_EDIT_FLIGHT_INFO: '/events/:eventID/draftFlightInfo/edit/:flightInfoID?',
    CONTACT_LIST: '/events/:eventID/contactList',
};
export default RouteConstants;
